"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _styles = require("@mui/material/styles");
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
var _helpers = require("../utils/helpers");
var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'inline-block',
      alignItems: 'baseline',
      maxWidth: '100%',
      padding: '2px 8px',
      borderRadius: 2,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      lineHeight: 1
    },
    body1: (0, _objectSpread2.default)({}, theme.typography.body2),
    body2: (0, _objectSpread2.default)({}, theme.typography.body2),
    body3: (0, _objectSpread2.default)({}, theme.typography.body3),
    body4: (0, _objectSpread2.default)({}, theme.typography.body3),
    body5: (0, _objectSpread2.default)({}, theme.typography.caption),
    color: {
      fontWeight: 400
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main,
      backgroundColor: (0, _styles.alpha)(theme.palette.primary.main, 0.08)
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main,
      backgroundColor: (0, _styles.alpha)(theme.palette.secondary.main, 0.08)
    },
    /* Styles applied to the root element if `color="positive"`. */
    colorSuccess: {
      color: theme.palette.success.main,
      backgroundColor: (0, _styles.alpha)(theme.palette.success.main, 0.08)
    },
    /* Styles applied to the root element if `color="negative"`. */
    colorError: {
      color: theme.palette.error.main,
      backgroundColor: (0, _styles.alpha)(theme.palette.error.main, 0.08)
    },
    /* Styles applied to the root element if `color="warning"`. */
    colorWarning: {
      color: theme.palette.warning.main,
      backgroundColor: (0, _styles.alpha)(theme.palette.warning.main, 0.08)
    },
    /* Styles applied to the root element if `color="neutral"`. */
    colorNeutral: {
      color: theme.palette.neutral.main,
      backgroundColor: (0, _styles.alpha)(theme.palette.neutral.main, 0.08)
    },
    /* Styles applied to the root element if `color="info"`. */
    colorInfo: {
      color: theme.palette.info.main,
      backgroundColor: (0, _styles.alpha)(theme.palette.info.main, 0.08)
    },
    activeColor: {
      fontWeight: 500
    },
    /* Styles applied to the root element if `color="primary"`. */
    activeColorPrimary: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main
    },
    /* Styles applied to the root element if `color="secondary"`. */
    activeColorSecondary: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main
    },
    /* Styles applied to the root element if `color="success"`. */
    activeColorSuccess: {
      color: theme.palette.success.contrastText,
      backgroundColor: theme.palette.success.main
    },
    /* Styles applied to the root element if `color="negative"`. */
    activeColorError: {
      color: theme.palette.error.contrastText,
      backgroundColor: theme.palette.error.main
    },
    /* Styles applied to the root element if `color="warning"`. */
    activeColorWarning: {
      color: theme.palette.warning.contrastText,
      backgroundColor: theme.palette.warning.main
    },
    /* Styles applied to the root element if `color="neutral"`. */
    activeColorNeutral: {
      color: theme.palette.neutral.contrastText,
      backgroundColor: theme.palette.neutral.main
    },
    /* Styles applied to the root element if `color="info"`. */
    activeColorInfo: {
      color: theme.palette.info.contrastText,
      backgroundColor: theme.palette.info.main
    },
    outlined: {
      border: '1px solid'
    }
  };
};

/**
 * HiColoredLabel
 *
 * Label with background color & text color
 */
function HiColoredLabel(props) {
  var classes = props.classes,
    className = props.className,
    fontSize = props.fontSize,
    label = props.label,
    propsColor = props.color,
    active = props.active,
    outlined = props.outlined,
    fontWeight = props.fontWeight,
    style = props.style,
    theme = props.theme,
    other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "fontSize", "label", "color", "active", "outlined", "fontWeight", "style", "theme"]);
  var color = propsColor || 'primary';
  var isHiColor = ['primary', 'secondary', 'success', 'error', 'warning', 'neutral', 'info'].includes(color);
  var isHexColor = !isHiColor && /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(color);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.color, !active), classes.activeColor, active), classes.outlined, outlined), classes["activeColor".concat((0, _helpers.capitalize)(color))], active && isHiColor), classes["color".concat((0, _helpers.capitalize)(color))], !active && isHiColor), classes.body1, fontSize >= 15), classes.body2, fontSize === 14), classes.body3, fontSize === 13), classes.body4, fontSize === 12), classes.body5, fontSize <= 11), className),
    style: (0, _objectSpread2.default)({}, style, {}, isHexColor && {
      backgroundColor: active ? color : (0, _styles.alpha)(color, 0.08),
      color: active ? theme.palette.getContrastText(color) : color
    }, {}, fontWeight && {
      fontWeight: fontWeight
    })
  }, other, {
    title: label
  }), label);
}
HiColoredLabel.defaultProps = {
  active: false,
  color: 'primary',
  fontSize: 15,
  outlined: false
};
var _default = exports.default = (0, _withStyles.default)(styles, {
  hiComponent: true,
  withTheme: true,
  name: 'HmuiHiColoredLabel'
})(HiColoredLabel);